import { Flex } from "@mantine/core";
import ClientImports from "./ClientImports";
import NoteImports from "./NoteImports";
import PaymentMethodImports from "./PaymentMethodImports";
import PaymentHistoryImports from "./PaymentHistoryImports";
import SubscriptionImports from "./SubscriptionImports";
import { useParams } from "react-router-dom";
import { PATH_NAMES } from "src/utils/constants";
import { useAppContext } from "src/api/AppContext";

function DataMigration() {
  const { locId = "" } = useParams();
  const { currentLocation } = useAppContext();
  const currentLocationId =
    locId === PATH_NAMES.GENERAL_LOC ? currentLocation?.id! : locId;

  return (
    <Flex direction={"column"} gap={"xs"}>
      <ClientImports locId={currentLocationId} />
      <NoteImports />
      <PaymentHistoryImports locId={currentLocationId} />
      <PaymentMethodImports locId={currentLocationId} />
      <SubscriptionImports locId={currentLocationId} />
    </Flex>
  );
}

export default DataMigration;
